// extracted by mini-css-extract-plugin
export default {"name":"styles-module__name__src-labstep-web-components-Group-Item-_zEO73","item":"styles-module__item__src-labstep-web-components-Group-Item-_wdmNj"};